import { callServerAPI } from "../helpers/Utils";
import { EmailDeliveryLogDetail, EmailDeliveryLogPagedResponse, EmailDeliveryLogQuery, ServerAPIResponse } from "../helpers/InterfacesServer";

const api = "/api/EmailDeliveryLog";
const unwrap = <T,>(response: { data: ServerAPIResponse<T> }) => response.data.data;

function queryString(query: EmailDeliveryLogQuery) {
    const params = new URLSearchParams();
    Object.entries(query).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') params.set(key, String(value));
    });
    return params.toString();
}

export async function getEmailDeliveryLogs(query: EmailDeliveryLogQuery) {
    return unwrap(await callServerAPI<ServerAPIResponse<EmailDeliveryLogPagedResponse>>(
        'GET', `${api}/GetEmailDeliveryLogs?${queryString(query)}`, null, false));
}

export async function getEmailDeliveryLog(id: number) {
    return unwrap(await callServerAPI<ServerAPIResponse<EmailDeliveryLogDetail>>(
        'GET', `${api}/GetEmailDeliveryLog?id=${id}`, null, false));
}
